import blocks from './blocks'
import trends from './trends'
import infographics from './infographics'

export default [
  {
    title: 'CH. 1',
    description: 'Foreword',
    identifier: 'ch1',
    children: [
      {
        title: 'Introducing the Moda Operandi Runway Report'
      }
    ]
  },
  {
    title: 'CH. 2',
    description: 'The Findings',
    identifier: 'ch2',
    children: [
      ...blocks.map((block) => ({
        title: block.title,
        identifier: block.name
      })),
      ...trends.map((trend) => ({
        title: trend.title,
        identifier: trend.identifier
      })),
      {
        title: 'The Top Colors',
        identifier: 'the-top-colors'
      }
    ]
  },
  {
    title: 'CH. 3',
    description: 'Digging Deeper',
    identifier: 'ch3',
    children: [
      ...infographics.map((info) => ({
        identifier: info.identifier,
        title: info.title
      })),
      {
        title: 'The Most Runway-Obsessed Cities',
        identifier: 'runway-obsessed-cities'
      },
      {
        title: 'Most Searched-For Luxury Fashion Terms',
        identifier: 'most-searched-fashion'
      },
      {
        title: 'Shopping Sessions, By the Numbers',
        identifier: 'shopping-sessions'
      },
      {
        title: 'Star Power',
        identifier: 'star-power'
      }
    ]
  }
]
